// src/lang/zh-CN.js （简体中文）
export default {
    menu: {
        home: '首页',
        about: '关于我们',
        aboutGroup: '集团介绍',
        corporateCulture: '品牌文化',
        brandHistory: '品牌历程',
        brandPromotion: '推广宣传',
        news:'新闻动态',
        productShowcase:'5X产品',
        teaSeries: '茶业系列',         // 茶业系列（泛指茶叶相关产品）
        teaDrinkSeries: '茶饮系列',  // 茶饮系列（强调饮品形态）
        teaSetSeries: '茶器系列',  // 茶器系列（茶具、器皿类）
        teaBanquetSeries: '茶宴系列', // 茶宴系列（茶主题宴席）
        teaCabinSeries: '茶舱系列',     // 茶舱系列（若指茶空间/仓储相关）
        groupControl:'集团管控',
        jobRecruitment:'人才招纳',
        socialResponsibility: '社会责任',  // 社会责任
        publicWelfare: '公益帮扶助力',        // 公益帮扶助力
        agricultureView: '三农优选计划',     // 三农优选计划（"三农"为大陆术语，繁体中可直接使用，或根据受众调整为"農業、農村、農民"相关表述）
        villageView: '乡村振兴战略',         // 乡村振兴战略
        healthyChina: '健康中国品牌',        // 健康中国品牌
        contact: '联系我们'                  // 联系我们
    },
    message: {
        langSwitchSuccess: '切换语言成功',
        langChinese: '已为您切换至中文简体模式',
        langTaiwan: '已为您切换至中文繁体模式', // 新增繁体提示
        langEnglish: '已为您切换至英文模式' // 新增英文提示
    },
    products: {
      title: '系列产品'  // 对应“系列产品”的键
    },
    AboutUsSection:{
        title: '构筑百年企业 传承荆楚文化',
        text: '三皮罐集团，自2009年创立以来，始终以“健康中国”为己任，践行“三茶统筹”理念，致力于成为引领未来健康生活的综合性平台。2024年，集团实现战略焕新，首创“茶+”新业态，构建起“茶、水、器、时、空”五维一体的产业生态，驱动价值链深度整合。',
        text2: '立足华中，辐射全球。集团业务网络已覆盖香港、北京、上海等核心城市，拥有40余家分子公司，形成强大协同效应。通过建设总部基地、超级水工厂、大健康产业园及原茶基地，我们打通“研、产、销”全链路，铸就可追溯的品质闭环，实力与动能持续攀升。',
        text3: '我们深植于荆楚沃土，以茶为媒，以创新为驱动，持续探索产业边界，开拓价值蓝海。在奠定百年基业的征程上，让文化传承为品牌发展注入永恒动力。'
    },
    AboutUsSectionStats: {
        farm: '种植基地',
        factory: '超级工厂',
        experience: '服务经验',
        city: '覆盖城市',
        unitMu: '亩', // 亩（面积单位）
        unitYear: '年', // 年（时间单位）
        unitPlus: '+' // 加号后缀
    },
    brandProText: {
        title: '三皮罐大健康',
        slogan: '自然、健康、正能量',
        description: '三皮罐的魅力，在于它用最简单的原料和工艺，诠释了 “大道至简” 的东方智慧。无论是传统冲泡的质朴，还是现代罐装的便捷，它始终以 “天然、健康、回甘” 为核心，既承载着四百年的文化记忆，又满足着现代人们对健康品质生活的追求。正如三皮罐集团总经理鲜文亮所言：“我们不是在做饮料，而是在传递一种生活方式。” 这种将自然、传统与创新融为一体的特质，让三皮罐成为一款值得品味、收藏和分享的 “有故事的产品”。'
    },
    sectionRenewal: {
        title: '5X焕新而来',
        subtitle: '传荆楚文脉 • 造健康生活'
    },
    moreBtn:'了解更多',
    fiveXItems: [
        {
            title: '茶',
            relationship: '茶业',
            icon: 'icon-chaye',
            description: '一叶承千古'
        },
        {
            title: '水',
            relationship: '茶饮',
            icon: 'icon-chayin',
            description: '一饮润乾坤'
        },
        {
            title: '器',
            relationship: '茶器',
            icon: 'icon-chaqi',
            description: '一罐传千年'
        },
        {
            title: '时',
            relationship: '茶境',
            icon: 'icon-chajing',
            description: '一境纳百川'
        },
        {
            title: '空',
            relationship: '茶界',
            icon: 'icon-chajie',
            description: '一界开新元'
        }
    ],
    EnterpriseNewsTitle:'企业动态',
    ViewDetails:'查看详情',
    FooterBar:{
        title:'服务热线',
        menuTitle:'关于我们',
        about:'集团介绍',
        Culture:'品牌文化',
        news:'新闻动态',
        qxtitle:'旗下产品',
        chaye:'茶业',
        chayin:'茶饮',
        chaqi:'茶器',
        chayan:'茶宴',
        chacang:'茶舱',
        responsibility:'责任与公益',
        publicWelfare:'公益之行',
        responsibilityView:'社会责任',
        Copyright:'版权所有 三皮罐大健康产业集团',
        siteMapView:'网站地图',
        adminLogin:'管理登录',
        goToData:'品牌数据',
        goToTea:'全球茶谱',
        goToTts:'溯源中心',
        layoutMap:'产业布局',
        ImageUploader:'上传图片'
    },
    proCultureImages: {
        culture1: 'https://minio.3pgkj.cn/3pg/2026/01/06/b7a3d4bb1c2f4af79b088feecb39cc6b.png',
        culture2: 'https://minio.3pgkj.cn/3pg/2026/01/06/07f2808cc97644d9a19fee25b8da246f.png',
        culture3: 'https://minio.3pgkj.cn/3pg/2026/01/06/80370897f2b843479be1d5d29ee789d2.png',
        culture4: 'https://minio.3pgkj.cn/3pg/2026/01/06/1f5f4fd872e44f62987b36417211e9b0.png',
        culture5: 'https://minio.3pgkj.cn/3pg/2026/01/06/98b1480bca7f4f6ead75174bb30f7a94.png'
    },
    posterBut:{
        ViewButton:'戳我查看详情',
        CloseButton:'关闭海报'
    },
    CultureBanner:{
        slides: [
            {
                imageUrl: 'https://minio.3pgkj.cn/3pg/2026/01/06/77a9d1c805954013933822e5589ff4d5.jpg',
                altText: '中国大健康产业品牌运营商',
                title: '中国大健康产业品牌运营商',
                description: '践行国家战略 聚焦产业发展 传承荆楚文化 构筑百年企业'
            }
        ],
        textContainer:{
            title:'大健康产业集团',
            description:'作为中国大健康产业品牌运营商，深度践行“健康中国2030”战略和“ 三茶统筹 ” 理念。以茶为媒，以创新为驱动，致力于构建引领未来健康生活方式的综合性产业平台。',
            description2:'集团成立于2009年，深耕产业投资、实体运营等多元化领域，奠定坚实发展基础。2024年，集团全新战略升级，创新引入“茶+” 新业态模式，推动产业价值链整合，逐步构建起“茶、水、器、时、空”五维一体的产业体系。以华中为战略原点，全力构建“辐射全国、链动全球”的发展格局。现布局香港',
            description21:'三皮罐茶器有限公司［3PG TEA WARE LIMITED］/ 三皮罐茶业(香港)有限公司［3PG TEA (HONG KONG) LIMITED］',
            description22:'、北京、上海、广州、深圳、成都、重庆、武汉等重点城市，共计40余家分子公司，形成广泛高效的业务网络。集团增长稳健，动能强劲，综合实力持续提升。',
            description3:'集团依托茶文化、运用茶科技、推动茶产业、发展新经济，全面构建大健康新经济生态体系。三皮罐总部、超级水工厂、大健康产业园、生态矿泉水水厂及原茶基地陆续开工建设，打造“研、产、销”全产业链闭环，构筑可溯的品质生态体系。',
            description4:'未来，集团将持续探索产业边界，开拓价值蓝海，以创新传承荆楚文化，以实力奠基百年企业。'
        },
        content:{
            title:'非遗代表 百年匠心 技艺传承',
            desc:'三皮罐茶是湖北地区独居特色的传统饮品，以湖北海棠叶为原料，因“三片叶子泡一壶茶”而得名，其饮用的历史渊源深厚，现存最早的文献记载可追溯至明末清初，跨越数百年的时光，依然飘香于市井巷陌。三皮罐承载着湖北人的乡土情结，随着时代变迁，其文化价值逐渐被重视，作为漳河新区非物质文化遗产代表性项目，它不仅仅是饮品，更是乡村振兴的文化名片，当下正通过文旅融合、非遗教育等途径焕发新生。',
            coreTitle:'一、自然与人文的共生',
            coreText:'三皮罐的流行与湖北的自然环境密不可分。野海棠树适应性强，耐旱抗寒，广泛分布于荆山余脉、江汉平原等地，尤以荆州、荆门、钟祥等地为盛。当地农人常在房前屋后种植此树，形成"田头砂壶三皮罐"的田园景象。',
            coreTitle2:'二、乡愁与诗意的交织',
            coreText2:'三皮罐承载着湖北人的乡土情结。游子离乡时常携带一包树叶，以茶味寄托乡愁，"烈日如蒸蝉声断，乡野酣歇戴帽轻。田头砂壶三皮罐，沁人心脾解暑饧"。三皮罐朴实无华的特质，亦被比作农人的品格。',
            coreTitle3:'三、非遗保护与创新融合',
            coreText3:'随着时代变迁，三皮罐的文化价值逐渐被重视。三皮罐凉茶作为漳河新区非物质文化遗产代表性项目，已不仅仅是饮品，更成为乡村振兴的文化符号，并通过文旅融合、非遗教育等途径焕发新生。',
            coreTitle4:'历史文化渊源',
            coreText4:'自明代以来，三皮罐的历史文化发展经历了茶饮发端、社会普及、工艺精进与文化沉淀以及当前的品牌重塑与全球化拓展四个阶段。',
            coreTitle5:'一、茶饮发端：从野生到茶饮(明代之前)',
            coreText5:'明万历《湖广通志》记载："江汉间有海棠树，叶厚可熬饮，民谓之土茶"，证实其从野生资源向生活用品的转化节点，"湖北海棠"也由此得名。2024年湖北钟祥明显陵出土的陶罐内残留物经检测含湖北海棠叶黄酮类物质，与三皮罐茶成分一致，为明代中叶江汉平原饮茶习俗提供物证。最终因"三片叶泡一罐"的定量冲泡方式得名三皮罐，成为江汉平原夏季解暑饮品，融入端午采叶、田间劳作等民俗场景。',
            coreTitle6:'二、社会普及：从日常药用到军需储备(1900年-1957年)',
            coreText6:'1915 年《中华药典》湖北分卷正式收录三皮罐的学名 “湖北海棠叶”，并首次科学证实其核心活性成分 “根皮苷” 的降血糖功效，这与民间长期将其称为 “消渴茶” 的实践认知形成完美互证。抗战时期(1943年)被列为军需物资，荆州档案馆留存调拨单显示年供应量达12万斤，凸显其社会功能扩展。',
            coreTitle7:'三、工艺沉淀：(1958-2023年)',
            coreText7:'三皮罐茶使用凝清叶片作为茶材，天然香气与清新的口感使其广受欢迎，尤其是荆门地区，民间诗歌为证："田头砂壶三皮罐，沁人心脾解暑饧"。1932年《荆门县实业调查报告》首次系统记录其制作流程："端午采叶，竹匾阴干，陶罐存储，沸水冲沏"强调传统工艺的稳定性。长期三皮罐以家庭自制的形式存在。原料采用当地特有的湖北海棠叶，制作工艺简单。这一时期的生产完全依赖手工，未形成规模化，但已融入荆门地方饮食文化，成为夏季解暑的必需品。',
            coreText77:'1958年湖北省供销社将其纳入"土特产品购目录"，推动家庭作坊向规模化生产过渡。随着健康饮食理念兴起和市场经济的兴起，三皮罐的工艺改良提上日程：一是原料筛选与种植：湖北海棠的规模化种植试验在荆门等地展开，尝试优化叶片采收周期和品质。二是加工技术革新：引入杀青机、揉捻机等设备，替代传统日晒和手工揉捻，提升效率并减少杂质污染。三是产品形态拓展：开发袋泡茶、速溶粉等便捷形式，但市场接受度有限，仍以散装茶叶为主。',
            coreTitle8:'四、品牌重塑与市场拓展',
            coreText8:'2024年武汉轻工大学研究证实其茶汤pH值(5.8-6.2)与天然抑菌性(绿原酸与根皮苷协同作用)，为工业化提供理论支持。2024年，三皮罐大健康集团在荆门漳河新区成立，标志着规模化和品牌化生产的突破。',
            coreTitle9:'水源地建设',
            coreText9:'依托漳河优质水源，规划建设现代化生产线，将传统工艺与现代技术结合，推出罐装茶产品。',
            coreTitle10:'品牌与文化整合',
            coreText10:'注册"三皮罐"系列商标，挖掘其400年历史底蕴，结合荆门地域文化进行品牌包装。',
            coreTitle11:'产学研合作',
            coreText11:'与科研机构合作，提取海棠叶中的活性成分(如黄酮类化合物)，开发功能性饮品。',
            coreTitle12:'关键技术与突破',
            coreText12:'传统工艺中"三片叶一壶茶"的配比被科学量化，通过恒温萃取技术稳定茶汤色泽和口感。从荆门本地向湖北及周边省份辐射，通过电商渠道进行地域扩张。将三皮罐与端午习俗、民间故事结合，申报非物质文化遗产，强化文化附加值。',
            coreTitle13:'地理区域',
            coreText13:'得益于丰富的水土资源和优越的气候条件，湖北地区的海棠树种植历史悠久，是三皮罐茶的重要产地之一。湖北海棠树适应性强，耐旱抗寒，多位于山坡、丘陵地区，这些地形条件利于茶树的栽培，茶叶的口感鲜爽，清香。得天独厚的资源优势为三皮罐的传承和创新提供了坚实的基础，推动了荆楚茶文化的持续发展。',
            coreText133:'荆门市下辖多个区、镇和乡，地理位置优越，交通便捷，地势以山地、丘陵、平原为主，整体呈现江汉平原特征，土壤肥沃，水源丰富。市内有多条河流穿流而过，主要河流包括长江的支流汉江，水系发达，为农业生产和海棠树种植提供了得天独厚的自然条件。',
            coreText1331:'水土资源的丰富使得该地区成为海棠树种植的理想之地。荆门市属于亚热带季风气候，四季分明，夏季高温多雨，冬季寒冷干燥。适宜的气候条件促使茶树的生长旺盛，尤其在温暖湿润的季节，茶树的生长速度较快，茶叶的品质也得以保证。荆门市的海棠树多位于山坡、丘陵地区，这些地形条件利于茶树的栽培，茶叶的口感鲜爽、清香。',
            coreText1332:'得益于丰富的水土资源和优越的气候条件，荆门市的海棠树种植历史悠久，以三皮罐茶为代表，独特的制作技艺使得该地成为三皮罐茶的重要产地之一。优越的自然环境和资源优势为三皮罐茶制作技艺的传承和创新提供了坚实的基础，推动了荆门市茶文化的持续发展。',
            coreTitle14:'非遗制茶工艺',
            coreText14:'2025年，三皮罐茶作为一种具有地域特色的茶饮，其制作技艺被列入非物质文化遗产名录。',
            skillCards:{
                label:'选材精细',
                strong:'嫩叶：',
                li:'以野生或规模化种植的海棠叶为原料，优选春季萌发的嫩芽和嫩叶，叶片完整无破损。',
                strong2:'完整：',
                li2:'叶片完整、无虫蛀或霉斑。',
                strong3:'地域：',
                li3:'以湖北荆门、荆州等地的野生或规模化种植海棠树为原料来源。',
            },
            skillCards2:{
                label:'茶叶采摘',
                strong:'时间：',
                li:'清明节前后采摘，茶树新芽肥厚饱满且富有香气，营养积累充分，易形成丰富的口感层次。',
                strong2:'采摘：',
                li2:'以“一芽一叶”或“一芽二叶”为主，确保嫩度与香气物质含量。保留叶片完整性，防止氧化。'
            },
            skillCards3:{
                label:'清洗除尘',
                strong:'清洗：',
                li:'将叶片清洗干净，去除杂质和尘土，清洗的过程中仔细检查叶片的完整度。',
                strong2:'除尘：',
                li2:'去除杂质和尘土。',
                strong3:'挑选：',
                li3:'清洗的过程中，对叶片的完整程度进行检查。',
            },
            skillCards4:{
                label:'上笼蒸制',
                strong:'蒸制：',
                li:'清洗后的叶片进行蒸制，固定茶叶的色泽与香气，使其更加耐泡和清新。',
                strong2:'激发：',
                li2:'通过蒸汽的加热，激发叶片中的天然香气。',
                strong3:'保持：',
                li3:'保持茶叶的原色，使其更加耐泡清新鲜，提升茶叶整体品质。',
            },
            skillCards5:{
                label:'晒干储存',
                strong:'平铺：',
                li:'蒸制后的叶片平铺竹匾上，阴凉通风处晾至半干，再晒至全干，既便于储存又高度保留原香。',
                strong2:'通风：',
                li2:'阴凉通风处晾至半干，再晒至全干(避免暴晒)。',
                strong3:'晾晒：',
                li3:'晒干后的茶叶呈现浅褐色，质地干枯。',
                strong4:'储存：',
                li4:'既便于储存，又能最大程度保留茶叶的原香。',
            },
            skillCards6:{
                label:'泡制茶汤',
                strong:'泡制茶汤：',
                li:'泡制后的茶汤色泽亮丽，生津止渴、清热解毒，富含茶多酚/黄酮类物质，是消暑佳品。',
                strong1:'传统功效：',
                li1:'生津止渴、清热解毒，夏季消暑佳品。具有消积化滞、和胃健脾的功效。',
                strong2:'现代研究：',
                li2:'富含茶多酚、黄酮类物质，具抗氧化、促进代谢等潜力。'
            },
            manifestation:{
                title:'价值体现',
                subtitle:'一、经济价值',
                normal:'三皮罐集团以漳河新区为核心，提出 “水源地超级工厂” 计划，依托漳河一类水质资源开发罐装凉茶产品，打造荆门本土健康饮品标杆。三皮罐茶作为独特的茶叶制作工艺，逐渐成为市场上独具特色的产品，吸引了茶叶爱好者与文化消费群体。通过三皮罐茶的品牌化运营及创新产品开发，相关企业和手工艺人不仅推动了传统茶产业的发展，还拓展了茶文化相关的旅游、礼品及文创产品市场，带动了当地的经济增长。结合现代电商平台的推广，三皮罐茶也能快速地走向更广泛的市场，进一步促进经济效益的提升。',
                normal2:'3月22日 “世界水日”，三皮罐集团与漳河新区签署战略协议，合作涵盖生态产品研发、健康旅游开发及水资源保护。新区政府表示，此举将推动水经济产业向高附加值方向升级。',
                normal3:'4月8日，三皮罐集团在第七届世界大健康博览会上与荆门市漳河新区签约，宣布 “天下茶舱” 项目将于5月1日启动运营。该项目整合茶科技、文旅康养资源，构建健康产业综合体。',
            },
            manifestation2:{
                subtitle:'二、文化价值',
                normal:'三皮罐茶的制作方法，体现了茶文化与传统哲学的有机融合，彰显了古人对细节和工艺的追求。“三皮罐，喝不厌”，“砂壶茶，过盛夏”，每一杯三皮罐茶的制作，都是对传统茶文化的再现和延续。集团加速推进三皮罐茶叶制作工艺及土陶罐技艺的非遗申请，计划建设 “水源地生态博物馆”，通过展览、天下茶舱等场景，将传统工艺转化为文化体验项目。总经理鲜文亮提出 “以茶和天下” 理念，旨在让三皮罐成为 “荆门对话世界” 的文化符号。'
            },
            manifestation3:{
                subtitle:'三、社会价值',
                normal:'在快节奏的生活方式中，三皮罐茶以其独特的制作工艺和品饮方式，成为现代人追求内心宁静、提升生活质量的一种方式。通过缓慢细致的泡茶过程，人们能够在静谧的时光中找到身心的放松，调节情绪。此外，三皮罐茶的保护与推广，也增强了公众对传统手工艺和文化遗产的认知与尊重，有助于社会对传统文化的传承和创新，为文化多样性的保护和艺术传承作出了贡献，进一步增强了社会的文化凝聚力与认同感。三皮罐通过挖掘土地的社会价值(如粗陶壶、锈红色茶汤等记忆符号)，重塑品牌与城市的情感联结。'
            },
            teaUpNew:{
                title:'"茶+"新业态',
                normal:'三皮罐大健康产业集团，是一家集多元产业布局与深厚地域文化底蕴于一体的综合性企业，集团通过文化引领、科技赋能、产业支撑的深度融合，激发茶产业的多元价值。集团秉承 “构筑百年企业，传承荆楚文化” 的价值追求，践行 “荆门漳河水，荆楚三皮罐” 的人文情怀，不仅致力于商业发展，还肩负着传承和弘扬荆楚文化的使命，力求在推动经济发展的同时，为社会文化传承贡献力量。',
                normal2:'泡三片海棠叶，解国民清凉——承载四百年江汉平原记忆的三皮罐茶，正从田间满扇摇入现代产业链，三皮罐以传统茶撬动健康消费浪潮，让乡愁滋味成为荆楚文化的新增长极。',
                subtitle:'茶叶产业',
                minor:'以绿色发展为方向，通过规模化种植、标准化加工和品牌化营销，构建富民产业体系，夯实乡村振兴基础。',
                subtitle2:'茶叶科技',
                minor2:'以创新技术驱动产业升级，涵盖数字化管理、品种培育、生态种植等，提升茶叶生产效率和产品附加值。',
                subtitle3:'茶叶文化',
                minor3:'以历史传承和文化创意为核心，挖掘非遗技艺，讲好品牌故事，为产业注入精神内核增强国际影响力。',
                subtitle4:'茶叶空间',
                minor4:'利用封闭式恒温恒湿茶仓，运用先进的技术存储确保茶叶品质打造超一流茶空间。',
                subtitle5:'茶叶服务',
                minor5:'以共享经济为核心理念，助力产业升级，打造无人化管理服务体系提升茶产业竞争力。',
                subtitle6:'茶叶生活',
                minor6:'配备先进的设备，为三皮罐文化与产业的发展搭建起沟通交流的优质平台。',
            },
            featuresData: [
                {
                title: "全国产业布局",
                text: "覆盖全国一线城市及主要枢纽，品牌高端化、渠道网络化、市场全国化。",
                img: "https://pic1.imgdb.cn/item/68ad2b8258cb8da5c84ef473.png"
                },
                {
                title: "三皮罐总部",
                text: "独特“JM”建筑形态打造荆门新地标。立面运用竖向铝方通的疏密变化和玻璃幕墙的反射，巧妙演绎虚实关系呈现强烈的现代雕塑感，构成荆门独特标志性的现代化科技大厦。",
                img: "https://pic1.imgdb.cn/item/68ad2b8258cb8da5c84ef476.png"
                }
            ]
        }
    },
    corporateCulture:{
        slides: [
            {
                imageUrl: 'https://pic1.imgdb.cn/item/68fc6cb93203f7be009e37c9.jpg',
                altText: '承荆楚文化，筑企业新篇',
                title: '承荆楚文化，筑企业新篇',
                description: '从荆楚田间的一壶传统凉茶，到辐射全国的大健康产业集团，三皮罐的发展历程，始终是一部品牌文化与产业实践深度交融的演进史',
                description2: '光阴流转，我们以“天然、健康”为初心基因，以荆楚文化为精神内核，在产业扩张中沉淀文化底蕴，在文化传承中驱动产业升级',
                description3: '让这一源自民间的品牌，成为承载地域文脉、对话时代需求的国民符号'
            }
        ],
        BrandStory:{
            title:'三皮罐 · 品牌故事',
            subTitle: '三片叶子一罐茶',
            storyText1:'三皮罐，学名“湖北海棠”（Malus hupehensis），是湖北鄂西地区特有的天然茶饮，历史可追溯至明末清初，其名称来源于泡茶的方式，即三皮(片)茶叶即泡一罐茶。',
            storyText2:'三皮罐的茶叶铜色铁绣，泡制后味道清香、甘甜，具有生津解渴、清热解暑、消炎杀菌等功效。是一种具有独特口感、丰富营养价值和深厚文化底蕴的凉茶饮料。因耐泡、解暑、物美价廉，而成为两湖地区百姓夏日消暑的必备饮品。因而有诗曰：',
            storyText2span:'“烈日如蒸蝉声断，乡野锄禾戴帽毡。田头砂壶三皮罐，沁人心脾解暑馋。',
            storyText22:'如今，三皮罐茶已被列为漳河新区非物质文化遗产代表性项目，其价值日益受到重视。它不再只是一味饮品，更成为湖北地域文化的鲜活符号，被赋予新的时代内涵，在创新中延续其历久弥新的生命活力。',
            storyText3:'得益于丰富的水土资源和优越的气候条件，湖北地区的海棠树种植历史悠久，是三皮罐茶的重要产地之一。得天独厚的资源优势也为三皮罐茶制作技艺的传承和创新提供了坚实的基础，推动了湖北茶文化的持续发展。',
            storyText4:'如今，三皮罐的价值逐渐被重视，作为漳河新区',
            storyText4span:'非物质文化遗产',
            storyText42:'代表性项目，它不仅仅是饮品，更成为湖北地方文化的符号，当下正通过文旅融合、非遗教育等途径焕发新生，在传承创新中延续荆楚文化。',
            mainTitle:'三皮罐作为中国大健康产业品牌运营商',
            mainTitletext:'践行“构筑百年企业，传承荆楚文化”的价值追求，秉承“荆门漳河水，荆楚三皮罐”的人文情怀，打造全产业链标杆的企业文化',
            valuesData: [
                {
                maxFont: "茶",
                title: "为人之道",
                text: "以茶载情，承续人文温度",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/fe23a02a99a34406a7ee0c5642c5206b.png"
                },
                {
                maxFont: "水",
                title: "为茶之母",
                text: "以水立基，守护本真滋味",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/5fca56ef19514ab38f6a3a61f7e6dc5b.png"
                },
                {
                maxFont: "器",
                title: "为茶之父",
                text: "以器传艺，链接古今匠心",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/9665bb7946c945c389477d62145f9265.png"
                },
                {
                maxFont: "时",
                title: "为茶之境",
                text: "以时为轴，平衡传统与当下",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/13e31b91c0944d8a8452729493de983b.png"
                },
                {
                maxFont: "空",
                title: "为茶之界",
                text: "以空为场，重构生态场景",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/631626862198444a9984b094a6b3d8f4.png"
                }
            ],
            conceptData: [
                {
                title: "依托茶文化",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/231b85d1c7f0480cbb66fd99deddb4bb.png"
                },
                {
                title: "运用茶科技",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/8a42694841154f239998420cde58af79.png"
                },
                {
                title: "推动茶产业",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/3faaedfb260340ddbd5509d804854711.png"
                },
                {
                title: "发展新经济",
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/c1dfafc3df9b4a269a6c1ac1a814b191.png"
                }
            ],
            items: [
                {
                    title: "价值观",
                    text: "自然、健康、正能量",
                    imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/bdb049da5ef848e5b7c15a50e5c786c0.png"
                },
                {
                    title: "生存之道",
                    text: "琴棋书画诗酒花，柴米油盐酱醋茶",
                    imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/9b53ba9f19ab4dffa30fdfc9b4934ef2.png"
                },
                {
                    title: "情怀",
                    text: "万丈红尘一壶酒，千秋大业一罐茶",
                    imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/754f8fbab789496e84c7077934ca5c93.png"
                },
                {
                    title: "定位",
                    text: "中国大健康产业品牌运营商",
                    imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/e8d4c71867da449dab625af3d126edf7.jpg"
                },
                {
                    title: "使命",
                    text: "构筑百年企业，传承荆楚文化",
                    imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/a51e6fe422984b90921dfcdb67675473.jpg"
                },
                {
                    title: "产品",
                    text: "致敬中国红，仰望中国星；传递中国情，品鉴中国茶",
                    imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/744e294ec9514987a4ff9251ca393934.jpg"
                }
            ],
            chacitems: [
                {
                title: '天下茶舱',
                description: '服务体系的点睛之笔，它让荆楚文化与现代科技碰撞：智能煮茶、自动茶舱服务、茶室、民宿、休闲切换营造 “一茶一境”，24小时自助服务打破时空限制，让都市人在钢筋森林中寻得一方 “第三生活空间”。其外观如星舰落尘，满溢未来科技质感，宛如穿越时空的茶之驿站。',
                image: 'https://minio.3pgkj.cn/3pg/2026/01/06/951e0bde9207499eaf1ac42facbe3cb8.jpg'
                },
                {
                title: '万里茶道',
                description: '服务体系的文化脉络。它循着古代商道的足迹，让茶香飘溢世纪。如今，三皮罐以这一文化符号为引，既传承荆楚文化的千年回响，也怀揣将中国茶文化推向世界的道路，让古道茶香在当代焕发新生。',
                image: 'https://minio.3pgkj.cn/3pg/2026/01/06/090edc2ad91a4779b3016237ade9a5d0.jpg'
                },
                {
                title: '世代茶人',
                description: '服务体系的精神传承。从古代茶农到现代从业者，一代又一代茶人守护着茶的本真，三皮罐珍视这份传承，以 “世代” 为诺，让制茶工艺、茶道精神在代际传递中愈发醇厚，如茶色般红亮温润，悠远绵长。',
                image: 'https://minio.3pgkj.cn/3pg/2026/01/06/4540a9f079954c0cae5d0753d01aa021.jpg'
                },
                {
                title: '根在荆楚',
                description: '服务体系的地域底色。三皮罐起源于明末清初的荆楚民间，农人以三片海棠叶煮凉茶解暑的习俗，藏着四代人的记忆。它在江汉平原、荆州、宜昌等地生根发芽，如今更以荆门为基，布局北上广深、香港等国际市场，让荆楚茶味飘向更远的地方。',
                image: 'https://minio.3pgkj.cn/3pg/2026/01/06/b8161ca26e78428c938b98cef4bb83b3.jpg'
                }
            ],
            brandData: [
                {
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/7d788b7763084bc7b74f085db40b3f9b.png",
                title: "中国健康品牌"
                },
                {
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/7eb48831ab28425788486c0f3f5cedcf.png",
                title: "乡村振兴攻略"
                },
                {
                imgSrc: "https://minio.3pgkj.cn/3pg/2026/01/06/91e78e17930842d7a1586c72db5ee855.png",
                title: "三农优选计划"
                }
            ]
        }
    },
    BrandHistory:{
        banner:{
            title:'大事记',
            text:[
                '从荆楚茶脉的千年传承到现代茶产业的创新实践，从三片叶的匠心坚守到 “茶、水、器、时、空” 的生态布局',
                '每一个关键节点都镌刻着三皮罐践行 “三茶统筹”、深耕大健康产业的足迹。翻阅此处，见证我们如何以茶为媒',
                '将文化底蕴、科技力量、健康理念、产业布局融入发展历程，一步步向 “依托茶文化、运用茶科技、推动茶产业、发展新经济” 的愿景迈进。'
            ]
        },
        breadcrumb:['首页','企业介绍','品牌历程'],
        mainTitle:'三皮罐品牌发展历程'
    },
    brandPromotion:{
        groInfo:{
            title:'承荆楚文化，筑百年企业',
            text:[
                '当你刷到三皮罐的短视频，读到解析茶产业的深度长文，从屏幕里的鲜活场景，到字里行间的专业厚度',
                '三皮罐用多元内容织就品牌网络，既让茶叶、茶饮、茶器等产品的品质被看见，又让 “荆楚文化、三皮罐茶” 等的品牌内核深入人心',
                '实现从 “认产品” 到 “信品牌” 的深度发展'
            ]
        },
        promotion:{
            title:['智能','驱动提效 + ','热点','追踪造势 + ','矩阵号','放量'],
            brandTitle:'“技术+内容+规模”的协同增长体系',
            desc:[
                '三皮罐以"茶文化+数字化"为重要支点，借电商直播、矩阵新媒体与数据驱动，构建"销售转化-品牌渗透-用户共情"全渠道链路，推动传统茶产业向大健康领域强势破局。',
                '携荆楚非遗凉茶基因破圈全国，让承载千年地域记忆的茶汤，成为国民健康饮品新潮流。线上打造茶业、茶饮、茶器、时空等产品矩阵，以"茶+"模式整合产业资源，形成"生产-体验-传播"一体化大健康生态圈。从荆楚文化符号到全国大健康标杆，三皮罐正以创新之姿，定义茶界健康新范式。'
            ],
            online:{
                title:'线上旗舰店',
                subtitle:'产品覆盖多个线上销售平台'
            },
            liveTitle:'直播场景展示',
            videoTitle:'短视频账号运营'
        }
    },
    NewsList:{
        title:'新闻动态 NEWS',
        text:[
            '在品牌成长的征程中，三皮罐的每一次进阶都凝聚着探索的力量。这里的集团新闻，是我们与您对话的 “动态窗口”',
            '既定格企业在产品创新、市场活动、社会责任上的深耕足迹，又解码企业发展与消费需求的前沿信号',
            '感谢您的驻足关注，从这些鲜活的叙事里，触摸三皮罐的发展脉搏，共探产业未来的无限可能'
        ],
        moreBtn:'查看详情',
        mainTitle:'新闻动态 NEWS',
        subTitle:'企业的成长都是一部波澜壮阔的史诗，记录市场的起伏更映射出时代的变迁与共同经历的回顾，<br>更是对未来航程的期许与规划。',
        breadcrumb:['新闻中心','新闻详情'],
        meta:['三皮罐大健康产业集团','发布','来自微信公众号文章','点击查看公众号新闻'],
        handleBack:'返回列表',
        nonews:'新闻不存在或已被删除',
        time: {
            justNow: '刚刚',
            minuteAgo: '{n}分钟前',
            hourAgo: '{n}小时前',
            dayAgo: '{n}天前',
            weekAgo: '{n}周前',
            monthAgo: '{n}月前',
            yearAgo: '{n}年前'
        }
    },
    ProductShowcase:{
        section:{
            chaye:{
                title:'茶',
                tab:'茶叶',
                slogan:'"三茶统筹"为引领，在传承古法技艺的基础上融合现代科技，构建覆盖种植、研发、生产、销售于一体的茶业体系'
            },
            chayin:{
                title:'水',
                tab:'茶饮',
                slogan:'承荆楚千年本草智慧，融现代健康生活理念，与现代消费需求完美融合，以“荆韵凉方”续写东方茶饮新篇'
            },
            chaqi:{
                title:'器',
                tab:'茶器',
                slogan:'以器定韵，承续古意。以匠心淬炼每一道工序，以文心打磨每一处细节，终成茶器完美诠释茶汤甘醇，更深载岁月人文底蕴。'
            },
            chayan:{
                title:'时',
                tab:'茶境',
                slogan:'重构传统空间体验的创新实践。打造不同风貌的茶文化体验生态系统，一时一境，让时光有味道，让生活有温度。'
            },
            chacang:{
                title:'空',
                tab:'茶界',
                slogan:'空间不仅是物理的容器，更是文化与生活的载体。三皮罐「茶界」以“茶+”理念重构人、空间与自然的关系，以茶之匠心重新定义现代人居。'
            }
        },
        header:{
            title:'时空匠造・5X 产品',
            text:[
                '从荆楚 “三皮罐” 百年配方的时光沉淀中走来',
                '我们以茶业、茶饮、茶器、茶宴、茶舱构建 5X 产品矩阵，在时间维度坚守古法淬炼工艺，融合现代萃取技术',
                '保留草本本真滋味，于空间维度覆盖 “品饮 - 使用 - 场景 - 体验” 全生态'
            ],
            breadcrumb:['首页','5X产品详情页'],
        },
        content:{
            chaye:{
                title:'茶业',
                bgCharacter:'茶',
                h2:'三皮罐茶、恩施硒茶',
                text:[
                    '三皮罐品牌承载着深厚的荆楚文化底蕴，其历史可追溯至明末清初时期，距今已有超过 400 年的历史。这一独特的名称源于其最朴素的饮用方式 ——"三片茶叶泡一罐"，形象地诠释了产品的核心特征。',
                    '恩施茶叶的历史可以追溯到非常久远的年代。据《华阳国志・巴志》记载，"武王既克殷，以其宗姬封于巴，爵之以子…… 丹、漆、茶、蜜…… 皆纳贡之…… 园有芳蒻、香茗。" 这表明不晚于西周时期，恩施就已开始种茶树、纳茶贡。恩施，是我国茶树起源地之一，茶叶种植历史可追溯到东汉时期，《桐君录》有文字记载，距离现在已有两千多年。恩施州是 "万里茶道" 的源头之一，自唐代起就是著名的贡茶产区。',
                    '三皮罐恩施硒茶以其天然、健康的品质特征在众多茶叶产品中独树一帜。品牌坚守 "天然、健康" 的核心理念，致力于为消费者提供最纯粹的茶饮体验。'
                ]
            },
            chayin:{
                title:'茶饮',
                bgCharacter:'水',
                h2:'三皮罐凉茶',
                h3:'0添加，健康无负担',
                text:'0能量，0香精、0色素、0防腐剂，满足控糖人群需求。通过ISO 22000食品安全管理体系认证，品质安全有保障。',
                featureTitle:'经典配方，匠心传承',
                desc:'以湖北荆楚地区传统"三皮罐"配方为灵感，精选海棠叶为核心原料。科学配比，遵循古法淬炼工艺，结合现代萃取技术，保留草本精华，去涩留香，适合四季饮用。',
                featureTitle2:'便捷罐装，畅饮随行',
                desc2:'采用310ml易拉罐包装，密封锁鲜，轻巧便携，适合户外、办公、运动、聚餐等多种场景。',
                featureTitle3:'文化赋能，提升溢价',
                desc3:'三皮罐作为湖北非遗项目，与地域文化深度绑定，助力其从地方性饮品升级为全国性健康茶饮品牌。',
                productitle:'富锶天然水',
                intro:'历经千年岩层渗透、矿脉淬炼，这一自然过程赋予了漳河水非凡的品质。富含多种对人体有益的矿物质和微量元素，让漳河水的口感更佳的清澈、甘冽。三皮罐遵循自然法则，仅以物理方式提取、净化，不添加、不干预，只为将这份来自大自然的纯净与滋养，原封不动地送至您的口中。',
                productitle2:'匠心天然',
                intro2:'在漳河核心保护区建立取水基地，远离污染，确保每一滴水都源自天然纯净之源。采用国际领先的微滤、超滤技术，去除杂质的同时保留天然矿物质，全程无菌灌装，杜绝化学添加，最大限度保留水的活性与天然口感。',
                productitle3:'锶水滋养',
                intro3:'锶是人体骨骼与牙齿的重要成分，可促进钙质吸收，预防骨质疏松。天然锶元素能清除体内自由基，延缓细胞老化，助您由内而外焕发年轻活力。锶参与人体酶活性调节，促进新陈代谢，尤其适合运动后饮用，快速补充电解质，恢复体能。',
                tags:[
                    '北纬30°黄金维度',
                    '富含多种微量元素',
                    '天然纯净无污染',
                    '锶含量≥0.20mg/L',
                    'PH＞8.4'
                ]
            },
            chaqi:{
                title:'茶器',
                bgCharacter:'器',
                danxuanxiang:[
                    '从千年前屈家岭的蛋壳黑陶，到唐代的邢窑白瓷、宋代的建窑兔毫盏，到如今匠人手作的紫砂壶、粗陶杯，茶器的材质与形态随时代流转，却始终守着一份初心：以器承茶，以茶载情。',
                    '它不必奢华，却藏着用心——杯沿贴合唇感，壶柄握得顺手。触摸茶器温度，看茶汤在器中舒展，便是人与茶、与生活的温柔对话。一杯茶的美好，从来离不开那只懂它的“器”。',
                    '在荆楚文化脉络中，陶器绝非普通盛茶器皿，而是匠人指尖流转千年的匠心结晶，是茶饮与制陶技艺交融的活态遗产。',
                    '这份传承深植制陶人骨血：从祖辈“选土观色、揉泥听声”的口传心授，到如今“不省工序、不凑火候”的坚守，每一代都以“守艺”托举技艺，郑重相传。从选土到成器，每一步皆循古法细节里藏着“器茶共生”的深刻理解——这是先辈总结的经验、代代相传的智慧，让茶器既承三皮罐甘醇，更载岁月人文温度。'
                ]
            },
            chayan:{
                title:'茶宴',
                bgCharacter:'时',
                intro:'茶宴之名，取自《茶经》，“茶为饮，最宜精行俭德之人” 荆楚大地，枕江襟湖，鱼米丰饶，孕育出 “鲜、香、醇、厚” 的饮食文化。茶宴汇聚江汉平原四时物产，借楚地烟火气，演绎 “一菜一格，百菜百味” 的舌尖传奇。茶宴不止提供美食，更致力于传承楚菜精髓，弘扬荆楚文化。愿君品尽世间味，归来仍是自在人。',
                tag:['随意·人生百态','随缘·天人合一','随心·禅茶一味'],
                tagsw:[
                    '茶宴之始，如人生初见，不求精致，但求自在。有人匆匆而来，饱腹即可；有人携友共聚，只求尽兴。如市井烟火，茶可浓可淡，菜可咸可甜，随性而食，方显生活本真。',
                    '茶至无味，方是真味；食至无求，方得至味。不拘于菜式，不执于口味，一箸一茶，皆是缘分。饮食不再是口腹之欲，而是自然文化的交融——茶中有天地，菜里有春秋。',
                    '不再囿于饱腹之欲，而是寻味而食，择心所向。或独坐一隅，慢品一壶老茶，佐以清雅小点，茶香入心，禅意自生；或三五知己，点几道合心意的菜肴，不贪多，不求全，只取所爱，食之有味.'
                ]
            },
            chacang:{
                title:'茶舱',
                bgCharacter:'空',
                desc0:'舱体采用镀锌环保材料建造，配备全屋智能控制语音系统、270°全景视窗及自助茶饮设备，用户可通过小程序实现 “一键预约、全程自助” 的私享体验，适用于商务、社交、休闲等多重场景',
                featureTitle:'全景沉浸式空间设计',
                desc:[
                    '270°环景视窗：',
                    '高透光率玻璃，无边框设计，实现全景环绕视野，昼夜景观无缝切换。',
                    '模块化舱体结构：',
                    '单舱12㎡，可容纳2-6人，支持自由组合扩展。生态友好设计：空气循环装置，实现低碳运行。'
                ],
                danxuanxiang:'全屋智能控制系统',
                featureDesc:[
                    '语音交互：',
                    '支持中英文语音指令，控制灯光、温湿度、背景音乐。',
                    '场景模式：',
                    '一键切换多种预设环境场景模式。',
                    '安全防护：',
                    '智能感应消防系统+紧急呼叫装置，全程云端保障。'
                ],
                danxuanxiang2:'智慧茶饮服务体系',
                desc2:[
                    '自助茶饮机：',
                    '提供多种精选茶品，AI智能推荐冲泡方案。',
                    '智能零食柜：',
                    '扫码即取本地特色茶点、健康轻食。',
                    '文化体验：',
                    '内置茶道教学，体验AI互动指导。'
                ],
                danxuanxiang3:'数字化运营支持',
                desc3:[
                    '预约系统：',
                    '微信小程序实时查看舱位状态、景观视角预览、在线选舱及支付。',
                    '会员体系：',
                    '积分兑换专属权益，更多优惠可选。',
                    '企业服务：',
                    '支持品牌专属空间定制。'
                ]
            }
        }
    },
    groupControl:{
        header:{
            title:'集团管控・匠筑生态',
            text:[
                '我们恪守 “专业深耕、协同共赢” 的经营底色，在战略规划、运营标准、中枢管控等维度层层锚定',
                '从产品矩阵的品质坚守，到分子公司的精准布局，从重点项目的全链路发展，到产业生态的长效构建',
                '集团管控始终是我们践行发展的硬核底盘。诚邀您共同见证我们以扎实管控筑牢发展根基、以长远雄心擘画品牌未来的笃定步伐'
            ]
        },
        mapTitel:'覆盖全国一线城市及主要枢纽城市',
        mapData:[
            {name:'行政区域',number:'5'},
            {name:'省份',number:'10'},
            {name:'办公场所',number:'40'},
            {name:'城市',number:'24'},
        ],
        mapInfo:[
            {region:'华南大区',info:['香港','深圳','广州']},
            {region:'华东大区',info:['上海','泰安','金华','安庆']},
            {region:'华西大区',info:['成都','重庆','贵阳','乌鲁木齐']},
            {region:'华北大区',info:['北京']},
            {region:'华中大区',info:['武汉','荆门','恩施','钟祥','襄阳','宜昌','赤壁','仙桃','潜江','十堰','天门','京山']}
        ],
        cityImgData:[
            {
            name:'广州·白云·大都会',
            img:'https://pic1.imgdb.cn/item/68fb8fee3203f7be00994cfc.jpg'
            },
            {
            name:'武汉·洪山·保利国际中心',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655956.jpg'
            },
            {
            name:'深圳·福田·嘉里中心',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655959.jpg'
            },
            {
            name:'上海·浦东·华南大厦',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655958.jpg'
            },
            {
            name:'北京·西城·德胜大厦',
            img:'https://pic1.imgdb.cn/item/68b3a97158cb8da5c8655954.jpg'
            },
            {
            name:'成都·金牛·国宾时光汇',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655955.jpg'
            }
        ],
        addressList: [
            { title: '华北区北京办公室', phone: '010-82960238', address: '北京市西城区皇寺大街大街德胜置业大厦1号楼1706' },
            { title: '华西区成都办公室', phone: '028-85026677', address: '成都市金牛区金科北路一招鲜大厦' },
            { title: '华东区上海办公室', phone: '021-56699999', address: '上海市浦东新区东方路1988号华南大厦404' },
            { title: '华中区武汉办公室', phone: '027-83839015', address: '武汉市光谷电子工业园3期6栋东二楼' },
            { title: '华南区深圳办公室', phone: '0755-23309999', address: '深圳市福田区中心四路1号嘉里建设广场三座1404' },
            { title: '驻外香港办公室', phone: '00852-60997141', address: '湾仔区告士打道200号 新银集团中心2702' }
        ],
        infoItem:['电话：','地址：'],
        sectionTitle:'超级水工厂',
        desc:'依托漳河水库连续14年稳定保持的国家Ⅰ类优质水源，三皮罐公司前瞻布局200亩综合性生产基地。未来，这里不仅是智造中心，更将是“水+”产业的展示窗口，通过水资源与文旅、科技、农业的立体联动，将生态优势转化为澎湃的发展动能。',
        sectionTitle2:'文化产业园',
        desc2:'根植于楚文化与三国史诗的厚重土壤，三皮罐在荆州，以一杯地方茶饮为基点，构筑一个融汇品牌、体验与创意的文化产业集群，旨在将地方风味升华为一张崭新的城市文化名片。',
        sectionTitle3:'大健康产业园',
        desc3:'立足钟祥“长寿之乡”的生态禀赋，三皮罐打造以“大健康”为核心的“一核四驱”产业综合体。通过聚合产品研发、共享直播、包装生产与生活配套等功能，项目将形成闭环生态，驱动品牌升级与乡村振兴，为钟祥经开区注入强劲发展活力。',
        sectionTitle4:'原茶基地',
        desc4:'三皮罐恩施茶工厂坐落于“世界硒都”湖北恩施宣恩县，依托当地独特的富硒土壤，专注茶叶全产业链运营。工厂以“地理优势+品牌势能+科技赋能”三位一体模式，深耕富硒健康茶饮赛道，打造具有硒都特色的标志性品牌。',
        sectionTitle5:'光谷电商基地',
        desc5:'三皮罐正式落子武汉光谷，建立全新的电商与数字化运营基地。此举旨在借助光谷的人才与科技资源，构建品牌面向未来的数字新基建，以创新营销链接全国市场，开启品牌发展的新篇章。',
        subtitle:'三皮罐聚焦武汉光谷，走向全国。',
        subText:[
            '运用现代科技手段，通过“技术+内容+规模”的协同增长体系，实现智能驱动提效+热点追踪造势+矩阵号放量的品牌运营模式，致力打造“茶科技+楚文化”双核驱动的华中茶业数字化中枢。',
            '通过“数字化供应链+文化IP”双向赋能，激活万亿级茶消费市场。引领茶产业从传统批发向“科技+文化”的数字化转型升级。成为三皮罐走向全国的强大引擎。'
        ],
        subtitle2:'缙云山水源地',
        subText2:'三皮罐集团以战略远见，于重庆北碚嘉陵江温塘峡畔布局生态智慧矿泉水基地。项目充分激活缙云山的生态禀赋与现有工业用地，以“工业+旅游”模式联动温泉、文旅与康养，将缙云山的生态价值转化为共生共荣的大健康产业生态圈。',
        subtitle3:'水源地生态条件优越',
        subText3:'缙云山矿泉水基地位于国家级自然保护区缙云山麓，该区域森林覆盖率极高，拥有2407种植物和1071种动物，生物多样性丰富，形成了天然的生态屏障。',
        subtitle4:'水质天然且富含矿物质',
        subText4:'缙云山矿泉水属于天然矿泉水，其锶含量达1.17—1.82毫克/升，偏硅酸含量27毫克/升，均达到国家标准界限指标。锶元素能软化血管、强壮骨骼，偏硅酸则有助于调节神经和肠胃功能。',
        secondary:'未来，三皮罐集团将持续以茶文化激活产业底蕴，以茶科技突破发展边界，在推动茶、水、器、时、空等核心产品创新发展的同时，深化茶产业链协同，培育新经济业态。秉持 “构筑百年企业，传承荆楚文化” 的愿景，集团将在巩固发展优势的基础上拓展全球布局，以产业创新赋能新经济发展，全力向全国性产业领军品牌、大健康产业标杆迈进。',
        hubeiCities:[
            { name: '武汉市', value: [114.3162, 30.5928, 100] },
            { name: '荆门市', value: [112.1900, 31.0200, 80] },
            { name: '荆州市', value: [112.2400, 30.3800, 70] },
            { name: '襄阳市', value: [112.1400, 32.0000, 90] },
            { name: '宜昌市', value: [111.3000, 30.7000, 85] },
            { name: '钟祥市', value: [112.3400, 31.1000, 60] },
            { name: '恩施市', value: [109.4800, 30.1800, 75] },
            { name: '成都市', value: [104.0665, 30.5723, 95] },
            { name: '乌鲁木齐市', value: [87.6168, 43.8256, 80] },
            { name: '贵阳市', value: [106.7135, 26.5783, 75] },
            { name: '安庆市', value: [117.0572, 30.5243, 70] },
            { name: '重庆市', value: [106.5504, 29.5637, 90] },
            { name: '广州市', value: [113.2644, 23.1291, 100] },
            { name: '深圳市', value: [114.0579, 22.5431, 95] },
            { name: '香港特区', value: [114.19,22.28, 95] },
            { name: '济南市', value: [117.0009, 36.6512, 85] },
            { name: '北京市', value: [116.4074, 39.9042, 100] },
            { name: '上海市', value: [121.4737, 31.2304, 100] },
            { name: '昆明市', value: [102.834304,24.878885, 100] } 
        ]
    },
    JobRecruitment:{
        title:'中国大健康产业品牌运营商',
        text:'构筑百年企业  传承荆楚文化',
        placeholder:'搜索职位关键词',
        searchBtn:'搜索职位',
        label:'历史搜索',
        clear:'清空全部',
        address:'工作地址',
        jobNum:'发布岗位',
        jobInfo:[
            '投递邮箱：',
            '手机号码：',
            '联系方式：',
            '在招岗位：',
            '工作地点：',
            '刷新数据',
            '投送简历'
        ],
        jobList:[
            '招聘职位',
            '薪资',
            '工作地区',
            '人数',
            '学历',
            '发布时间',
            '职位状态',
            '查看详情'
        ],
        status:['招聘中','已截止'],
        detail:['职位介绍','专业要求','任职要求'],
        dialogVisible:['职位详情','招聘中','报名已截止','急','发布于','岗位介绍','岗位要求','福利待遇','工作地址','投递邮箱','复制邮箱','发送简历','保存分享','取消','朕知道了'],
        office:['致未来同行者：','办公环境'],
        historyKeywords: ['产品经理','美工设计','新媒体运营','视频剪辑'],
    },
    publicWelfare:{
        header:{
            title:'践行国家战略・共担时代责任',
            text:[
                '作为深耕行业的企业，三皮罐集团始终将社会责任视为发展的核心要义之一。我们以 “公益帮扶助力发展，战略践行彰显担当” 为理念',
                '积极投身公益事业，深度响应国家 “三农优选”“乡村振兴”“健康中国” 等战略部署',
                '旨在与广大客户、各界关心三皮罐的朋友一道，凝聚社会责任的强大合力。 让我们与时代同频，把企业责任的星火，变成共担责任’的燎原之势'
            ]
        },
        welfare:{
            title:'关爱暖“骑”“心”慰问活动',
            text:[
                '三皮罐集团与市场监管局、市“小个专”综合党委领导一同前往多个外卖、快递配送站点，为骑手们送上“三皮罐凉茶”等防暑物资。'
            ],
            footer:'三皮罐公益活动，用小小的一杯茶，传递着大大的爱。它不仅仅让传统茶饮焕发新生，更温暖了无数人的心灵，让公益之花在社会的各个角落绽放。'
        },
        section:{
            title:'“因您而美 因爱而行”公益活动',
            text:[
                '三皮罐将一箱箱凉茶送到正在街头清扫的环卫工人手中，传递社会对一线劳动者的尊重与关爱。'
            ],
            footer:'三皮罐作为一家心怀大爱的企业，始终秉持着回馈社会的理念积极投身公益事业。用点滴善举汇聚成爱的海洋，为社会公益事业贡献着自己的坚实力量。'
        },
        SilverAge:{
            title:'关爱银龄退役军人健康行',
            text:[
                '三皮罐作为“关爱银龄退役军人健康行”的赞助方为退役军人及工作人员送去夏日清凉与关怀。'
            ],
            footer:'从一杯凉茶的关怀出发，三皮罐集团正以坚定的步伐，书写着"军民同心"的新篇章。把这份关怀与敬意延续下去。力求在多个维度实现突破与发展，为社会创造更多价值。'
        },
        Malas:{
            title:'全国残疾人马拉松的公益赞助',
            text:[
                '2025年5月10日，三皮罐赞助第六届肢残人马拉松比赛公益送水行动'
            ]
        }
    },
    agricultureView:{
        header:{
            title:'守护乡村生态・传承农耕文化',
            text:[
                '以 “三茶统筹” 筑根基，以 “茶 + ”业态拓场景，以 “5X 产品线” 赋价值 —— 三皮罐三农优选计划',
                '这一战略不仅实现了企业产业布局与三农发展的同频共振，更以实际行动守护乡村生态、传承农耕文化',
                '彰显了集团从 “产业发展者” 到 “三农赋能者” 的责任担当，为推动农业增效、农民增收、农村增美提供了 “三皮罐方案”'
            ]
        },
        section:{
            title:'以非遗技艺打造健康新方式',
            text:[
                '仲夏时节，骄阳似火，天地间万物蓬勃生长，展现出旺盛的生命力。如何在顺应自然规律的同时，运用科学的方法进行养生调养，成为当下大众关注的焦点。近日，三农优选(中国农业电影电视中心新媒体平台)以《夏日养生局》为主题，精心筹备了一场别开生面的养生盛会，共同探索非遗技艺与现代科技的养生新主张。',
                '作为扎根湖北近20年的老牌企业，三皮罐集团一直致力于大健康产业的发展。如今积极响应国家 “三茶统筹” 理念，将业务版图拓展至茶产业、特色文旅、生态农业、新型消费等多个领域，我们始终以 “构筑百年企业，传承荆楚文化” 为使命，以为 “依托茶文化、运营茶科技、推动茶产业、发展水经济” 为企业愿景。将三皮罐打造成荆楚大地的文化名片，不断探索创新，力求在传承中发展，在发展中传承。'
            ]
        },
        workmanship:{
            title:'工艺揭秘：独特工艺铸就品质',
            text:[
                '直播现场，鲜文亮总经理以亲切而专业的姿态，向观众娓娓道来三皮罐凉茶的起源以及三皮罐品牌的初心。三皮罐凉茶承载着湖北地区悠久的茶文化历史，是我们对传统养生智慧的传承与创新。我们始终坚信，每一杯三皮罐凉茶都不仅仅是一种饮品，更是一种文化的延续和情感的寄托，它承载着无数人儿时的记忆，是家乡的味道，是亲情的象征。',
                '鲜文亮总经理着重对比了三皮罐凉茶与传统茶饮料生产工艺差异。传统茶饮料生产流程复杂，高温消毒采用的技术虽能杀菌，但会破坏茶叶香气，使味道变淡、口感变差。而三皮罐凉茶精选优质原叶，无需炒制与发酵，采用萃取工艺，经30分钟122摄氏度恒温二次萃取，充分释放茶叶特性，保留天然香气与营养成分，再经冷却保鲜灌装，最终口感醇厚、香气四溢，尽显对传统工艺的尊重与现代科技的运用。'
            ]
        },
        makeanAppearance:{
            title:'直播赴约：携诚意产品亮相盛会',
            text:[
                '6月15日，我们怀着满腔的热情和专业的态度，受邀参与了本次三农优选《夏日养生局》直播活动。湖北三皮罐大健康产业集团总经理鲜文亮亲自带队，携公司精心打造的三皮罐凉茶与三皮罐原叶礼盒产品，奔赴北京中国农业电影电视中心新媒体平台，参与这场备受瞩目的直播节目录制。我们希望通过这个平台，将三皮罐的品牌故事和养生理念传递给更多的人。'
            ]
        },
        fusion:{
            title:'产业融合：创新模式拓展养生版图',
            text:[
                '此外，鲜文亮总经理还分享了三皮罐集团在生态农业与产业融合方面的创新突破。我们积极推动生态农业的发展，与当地农户建立了紧密的合作关系，采用绿色、环保的种植方式，确保茶叶的品质和安全。同时，我们将茶产业与特色文旅、新型消费等领域相结合，打造了多元化的茶文化服务综合体，为消费者提供了更加丰富、多元的养生体验。'
            ]
        },
        includes:{
            title:'非遗科技融合，续写养生新篇',
            text:[
                '此次参与《夏日养生局》直播活动，将会有让更多的人了解三皮罐品牌，认识三皮罐凉茶的独特魅力。未来，我们将继续秉承 “自然、健康、正能量” 的价值观；以 “构筑百年企业，传承荆楚文化” 的使命，不断加大研发投入，提升产品品质，拓展市场渠道，为广大消费者带来更多优质的养生产品和服务。我们相信，在非遗技艺与现代科技的融合下，三皮罐集团必将开启养生新征程，书写更加辉煌的篇章。'
            ]
        }
    },
    villageView:{
        header:{
            title:'激活乡土价值・共绘和美乡村图景',
            text:[
                '集团乡村振兴战略以国家乡村振兴战略为根本遵循，以 “茶” 为核心纽带激活乡村内生动力，让荆楚乡土文化触达更广泛人群',
                '这一战略不仅实现了企业产业优势与乡村发展需求的精准对接，更以生态优先、文化传承为底线，在推动茶生态、技艺传承的过程中',
                '为乡村振兴提供 “产业兴、农民富、农村美” 的可复制实践方案，彰显了民族企业服务国家战略、反哺乡村发展的责任与担当'
            ],
            hero:'三皮罐的三茶项目在实现乡村全面振兴、共同富裕的过程中，扮演着提升乡村文化品位、激活茶产业链经济、促进农民增收与就业、以及推动乡村可持续发展的关键角色，是连接传统与现代、文化与经济的重要桥梁。'
        },
        content:{
            title:'共同富裕战略的积极响应',
            feature:[
                '2025 年中央一号文件明确提出，要坚持农业农村优先发展，坚持城乡融合发展，锚定推进乡村全面振兴、建设农业强国目标。三皮罐集团的乡村振兴计划与这一国家战略高度契合，通过产业带动、文化赋能、科技创新等多重路径，为实现共同富裕贡献企业力量。',
                '从 "产业发展、要素流动、服务提升、治理有效" 四个维度出发，三皮罐集团构建了完整的乡村振兴生态体系。在产业发展上，集团以万亩茶园为根基，依托茶文化，运用茶科技，推动茶产业发展；在要素流动上，通过 "茶 +" 新业态模式，促进资金、技术、人才等要素向农村流动；在服务提升上，建设 "天下茶舱" 等文化体验设施，提升农村公共服务水平；在治理有效上，通过企业化运作模式，为乡村治理现代化提供新路径。'
            ],
            agriculture:{
                title:'农业农村科技现代化的创新实践',
                text:'《加快建设农业强国规划 (2024-2035 年)》强调，要以农业关键核心技术攻关为引领，以产业急需为导向，加快以种业为重点的农业科技创新。三皮罐集团在这一战略指引下，积极推进农业科技现代化，成为农业新质生产力的重要实践者。'
            }
        },
        Travel:{
            title:'乡村全面振兴战略的系统对接',
            text:[
                '《乡村全面振兴规划 (2024—2027 年)》要求统筹推进农村经济建设、政治建设、文化建设、社会建设、生态文明建设和党的建设，实现乡村全面提升。三皮罐集团的乡村振兴计划与这一系统性要求高度吻合，形成了 "五位一体" 的综合发展模式。',
                '在经济建设方面，集团通过发展茶产业、水经济、文旅产业等，构建多元化的产业体系。',
                '在文化建设方面，集团致力于传承和弘扬荆楚文化，力求在推动经济发展的同时，为社会文化传承贡献力量。三皮罐品牌起源于湖北荆楚民间传统凉茶，当地农人以三片野海棠叶泡制解暑茶饮的习俗，承载着几代人的记忆。集团通过产品创新和文化传播，让这一传统饮品焕发新生。',
                '在生态建设方面，集团注重绿色发展，建设 "水源地超级工厂"。通过水资源保护与利用、生态茶园建设、循环经济发展等措施，实现经济效益与生态效益的有机统一。',
                '在社会建设方面，集团积极履行社会责任，开展 "夏日送清凉" 活动，为环卫工人、快递小哥等户外工作者提供防暑饮品。2025 年 7 月，集团捐赠 1000 件防暑饮品，为守护城市洁净的劳动者们送上贴心关怀。'
            ]
        },
        innovation:{
            title:'产业链整合的创新模式',
            text:'三皮罐集团通过产业链整合，构建了 "从茶园到茶杯到时间到空间" 的全产业链体系，实现了一二三产业的深度融合。这种整合模式不仅提高了产业效率，更重要的是让农民能够分享产业链各环节的增值收益。'
        },
        practice:{
            title:'文旅融合的创新实践',
            text:'三皮罐集团将茶文化与旅游产业深度融合，打造了独特的茶旅融合模式。集团长期聚焦茶产业与大健康融合，通过整合文旅、农业资源，构建多元化健康产业综合体。',
            feat:{
                title:'"天下茶舱" 项目',
                text:'"天下茶舱" 项目是文旅融合的标志性工程。太空茶舱以 "未来茶空间" 为概念，将荆楚茶文化与现代科技深度融合。营造 "一茶一境" 的沉浸式氛围；24 小时自助服务通过扫码预约、自助冲泡，让茶文化突破时间与空间的限制，成为都市人的 "第三生活空间"。'
            },
            feat2:{
                title:'"三皮罐之夜" 演唱会',
                text:'"三皮罐之夜" 演唱会等文化活动成为文旅融合的新亮点。2025 年 10 月 6 日，"三皮罐之夜" 华语巨星演唱会现场人潮攒动，2 万余名观众前来体验这场音乐盛会，带动周边餐饮、住宿企业营业收入增长。这种 "文化 + 旅游 + 商业" 的模式，不仅提升了城市知名度，也为当地经济发展注入了新活力。'
            }
        },
        promote:{
            title:'多元担当的社会价值',
            text:[
                '在品牌赋能方面，集团通过品牌建设和市场推广，提升产品附加值。三皮罐作为荆楚地区的传统饮品，具有深厚的文化底蕴。集团通过现代营销方式，将这一传统产品打造成时尚健康的现代饮品，产业助力的成效是显著的。',
                '三皮罐集团创新性地将农业、文化、旅游三大产业有机结合，打造了具有荆楚特色的农文旅融合发展模式。集团通过整合文旅、农业资源，构建多元化健康产业综合体，为乡村振兴探索了新路径。',
                '我们将持续提升三皮罐品牌的知名度和美誉度，打造成为具有荆楚特色、中国气派、世界影响的民族品牌。要注重品牌文化内涵的挖掘和传播，讲好三皮罐故事，提升品牌价值。同时，要加强国际市场开拓，让中国茶文化走向世界。',
                '展望未来，三皮罐集团的乡村振兴计划正站在新的历史起点上。随着项目的深入推进和模式的不断完善，这一计划必将在推动乡村全面振兴、实现共同富裕的伟大实践中发挥更大作用，为中国式现代化贡献更多智慧和力量。我们有理由相信，在国家战略的引领下，在企业的积极实践中，在社会各界的共同努力下，乡村振兴的美好愿景必将成为现实，亿万农民必将过上更加幸福美好的生活。'
            ]
        },
        number:['合作乡村','受益农户','收入增长','旅游人次']
    },
    HealthyChina:{
        header:{
            title:'践行健康使命・守护美好生活',
            text:[
                '三皮罐集团健康中国品牌战略深度锚定 “健康中国 2030” 战略目标，将 “三茶统筹” 理念作为健康产业发展的核心引擎',
                '以 “茶” 为健康载体构建全链条价值体系，以 “天然、安全、可持续” 的健康标准，为消费者提供全场景健康解决方案',
                '彰显了民族企业以产业之力助推全民健康、服务国家战略的坚定担当'
            ]
        },
        content:{
            title:'打造全国影响力茶品牌',
            text:[
                '固内布局：锚定文化根脉，构建健康生态',
                '作为中国大健康产业的核心品牌运营商，三皮罐集团深度践行"三茶统筹"发展理念，以传承400余年的荆州三皮罐茶文化为根基。依托百万亩生态园与漳河天然水基地两大核心资源，集团以茶产业为核、茶科技为翼，精准对接健康消费需求，建成智能化超级工厂与"天下茶舱"体验空间等标杆项目。',
                '目前，集团已在北京、上海、广州、深圳、武汉等10余座核心城市设立城市办公室，构建起覆盖全国的运营网络，并形成“茶、水、器、时、空”五大产品线体系，推动承载湖北人乡愁记忆的传统茶与现代健康生活方式深度融合。',
                '国际战略：链接全球资源，打造国际品牌',
                '为提升国际竞争力，集团以香港为国际业务中枢，统筹全球资源对接与品牌推广。通过整合产业链优势与科技创新成果——如强化三皮罐中根皮苷等有益成分的开发利用，集团正全力打造兼具地域文化辨识度与国际适配性的茶文化服务综合体，让这一源自荆楚的千年茶饮名片走向世界'
            ]
        },
        section:{
            title:'科技赋能，文化传承促发展',
            text:'三皮罐集团积极响应国家号召，将茶产业作为新的发展重点，致力于推动乡村产业振兴与茶文化传承。',
            card:{
                title:'恩施原茶基地',
                text:'在恩施州打造"世界硒都"茶产业标杆项目，占地面积6574㎡，厂房面积39966㎡，办公楼452㎡，品茶室932㎡。通过科技赋能传统茶业，发展硒茶叶深加工产业，预计年产值可达2亿元，带动当地茶农增收超千万元。'
            },
            card2:{
                title:'武汉电商基地',
                text:'依托"九省通衢"地理枢纽与长江经济带核心节点的物流优势，以高校人才为智力引擎，为新媒体电商提供了人才、智能供应链基建、政府扶持及楚文化内容壁垒的四重战略支点，计划在武汉拟建1300㎡的新媒体电商运营基地，助力打造数字经济新茶名片。'
            },
            card3:{
                title:'荆州茶文旅综合产业园项目',
                text:'2025年，集团旗下子公司依法通过司法拍卖取得荆州市荆州区两处优质资产，土地使用权面积4662.73㎡，计划投资打造集茶文化展示、生产研发、文旅服务于一体的综合性项目。项目建成后，预计年接待游客超10万人次，带动当地就业超500人。'
            }
        },
        crossover:{
            title:'跨界融合，创新驱动新未来',
            text:'三皮罐集团在产业升级与转型方面不断探索与实践，积极寻求跨界融合与创新发展。',
            card:{
                title:'重庆缙云山泉水基地',
                text:'成功竞得缙云山矿泉水生产基地，土地使用权82755.5㎡，建筑面积12357.82㎡。基地采用全封闭式无菌生产链，建立水循环系统，动态调整开采量，确保水源可持续。预计年产量可达5000万瓶，年产值超3亿元。'
            },
            card2:{
                title:'钟祥大健康产业园',
                text:'投资建设以"大健康产业"为核心的"一核四驱"生态型商业综合项目，占地约200亩，总规划建筑面积超10万㎡，计划投资约5亿元。项目涵盖产品研发、共享直播、人才公寓、包装生产、酒店餐饮等多个板块，预计年产值可达8亿元，带动当地就业超1000人。'
            },
            card3:{
                title:'漳河水源地生产基地',
                text:'依托漳河水库优质水资源，投资建设综合性生产基地。项目占地约200亩，总规划建筑面积超10万㎡，计划投资约7.5亿元。基地配备两条高度自动化生产的灌装生产线，生产速度可达单线3.6万罐/时，全面投产以后，年总产量可达2000万标箱，比传统工厂节约用工60%以上。'
            },
            card4:{
                title:'绿色发展，共筑美好未来',
                text:[
                    '三皮罐集团作为一家多元化、跨领域发展的综合性企业，在地产开发、茶产业与乡村振兴、产业升级与转型等方面取得了显著成就。',
                    '未来将继续秉承"依托茶文化、运用茶科技、推动茶产业、发展新经济"的愿景，以茶科技赋能产业升级、以茶文化激活品牌价值、以茶产业带动融合发展，加快打造具有全国影响力的三皮罐茶品牌。为地方经济社会发展注入新动能，为共筑美好未来贡献。'
                ]
            }
        }
    },
    ContactPage:{
        header:{
            title:'联系我们 共筑联结',
            text:[
                '作为中国大健康产业品牌运营商，三皮罐集团始终以 “真诚、高效、专业” 的态度，搭建与广大客户、合作伙伴及关注者的沟通桥梁。',
                '这里是您了解三皮罐、对接需求、共探发展的重要纽带，我们以用心服务的温度，传递品牌的专业品质与责任担当。'
            ]
        },
        message:{
            title:'在线留言',
            name:['请输入您的姓名','您的姓名'],
            contact:['请输入有效的电话或邮箱','联系电话或邮箱'],
            type:'请选择留言类型',
            option:[
                '产品咨询',
                '购买咨询',
                '售后咨询',
                '品牌合作',
                '市场活动咨询',
                '意见与建议',
                '招商加盟咨询',
                '企业信息咨询',
                '其他业务'
            ],
            captcha:'请输入验证码',
            content:['请输入留言内容（最多500字）','请输入留言内容'],
            button:['重置','提交留言'],
            cell:['联系方式','留言类型','留言内容','验证码']
        }
    },
    responsibilityView:{
        header:{
            title:'发展与责任共生 • 初心与使命同行',
            text:[
                '2009年创立以来，三皮罐大健康产业集团始终扎根荆楚大地，以“构筑百年企业，传承荆楚文化”为价值追求',
                '在“文化引领、科技赋能、产业发展”的发展战略中深度融入社会责任理念。从一片茶叶到多元产业生态，从地域品牌到全国布局',
                '集团始终坚信：企业的长远发展必然与社会价值创造同频共振，社会责任不是发展的“附加题”，而是驱动高质量发展的“核心引擎”'
            ]
        },
        section:{
            title:'践行国家战略 共担时代责任',
            text:'作为深耕行业的企业，三皮罐集团始终将社会责任视为发展的核心要义之一。我们以 “公益帮扶助力发展，战略践行彰显担当” 为理念，积极投身公益事业，深度响应国家 “三农优选”“乡村振兴”“健康中国” 等战略部署，旨在与广大客户、各界关心三皮罐的朋友一道，凝聚社会责任的强大合力。让我们与时代同频，把企业责任的星火，变成共担责任的燎原之势。'
        },
        section2:{
            title:'守护乡村生态 传承农耕文化',
            text:'以 “三茶统筹” 筑根基，以 “茶 +” 业态拓场景，以 “5X 产品线” 赋价值 —— 三皮罐三农优选计划，这一战略不仅实现了企业产业布局与三农发展的同频共振，更以实际行动守护乡村生态、传承农耕文化，彰显了集团从 “产业发展者” 到 “三农赋能者” 的责任担当，为推动农业增效、农民增收、农村增美提供了 “三皮罐方案”。'
        },
        section3:{
            title:'激活乡土价值 共绘和美乡村图景',
            text:'集团乡村振兴战略以国家乡村振兴战略为根本遵循，以 “茶” 为核心纽带激活乡村内生动力，让荆楚乡土文化触达更广泛人群。这一战略不仅实现了企业产业优势与乡村发展需求的精准对接，更以生态优先、文化传承为底线，在推动茶生态、技艺传承的过程中，为乡村振兴提供 “产业兴、农民富、农村美” 的可复制实践方案，彰显了民族企业服务国家战略、反哺乡村发展的责任与担当。'
        },
        section4:{
            title:'践行健康使命 守护美好生活',
            text:'三皮罐集团健康中国品牌战略深度锚定 “健康中国 2030” 战略目标，将 “三茶统筹” 理念作为健康产业发展的核心引擎，以 “茶” 为健康载体构建全链条价值体系，以 “天然、安全、可持续” 的健康标准，为消费者提供全场景健康解决方案，彰显了民族企业以产业之力助推全民健康、服务国家战略的坚定担当。'
        }
    },
    SiteMapView:{
        title:'网站地图'
    }
}
